module.exports = __webpack_public_path__ + "static/media/coxs1.2db84080.png";